import checkIsTicketGroupNotOnSale from './checkIsTicketGroupNotOnSale';
import checkIsTicketGroupShownInQuery from './checkIsTicketGroupShownInQuery';

export default function checkIsTicketGroupVisible({
  ticketGroup = {},
  query = {},
  isSoldOut = false,
  isOnSale,
  isCanceled,
  hasInvalidReference,
  isScheduled,
}) {
  if (ticketGroup.hidden) {
    const isTicketGroupShownInQuery = checkIsTicketGroupShownInQuery(ticketGroup.reference, query);

    if (isTicketGroupShownInQuery) return true;

    return false;
  }

  if (isSoldOut && ticketGroup.hideWhenSoldOut) {
    return false;
  }

  if (ticketGroup.hideWhenScheduled && isScheduled) {
    return false;
  }

  if (ticketGroup.hideWhenNotOnSale) {
    const isNotOnSale = checkIsTicketGroupNotOnSale({
      ticketGroup,
      isCanceled,
      isOnSale,
      isScheduled,
      hasInvalidReference,
    });

    if (isNotOnSale) {
      return false;
    }
  }

  if (ticketGroup.hideWhenUnavailable && ticketGroup.availabilityStatus === 'unavailable') {
    return false;
  }

  return true;
}
